import { BarrierStatus } from '../../../../shared/models/enums/barrier-status.enum';

export class DiagnosticBarrierDto {
  constructor(public id: number, public description: string, public barrierStatus: BarrierStatus, public barrierId: number) {}

  public static fromJson(json: any): DiagnosticBarrierDto {
    if (json) {
      return new DiagnosticBarrierDto(json.id, json.description, json.barrierStatus, json.barrierId);
    }
  }
}
